import { render } from "./NewsTwitter.vue?vue&type=template&id=9eb15fea&scoped=true"
import script from "./NewsTwitter.vue?vue&type=script&lang=js"
export * from "./NewsTwitter.vue?vue&type=script&lang=js"

import "./NewsTwitter.vue?vue&type=style&index=0&id=9eb15fea&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abscu\\OneDrive\\Desktop\\htmlcss\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9eb15fea"]])

export default __exports__